import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=517aa08f&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=517aa08f&prod&scoped=true&lang=css&"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=517aa08f&prod&lang=css&"
import style2 from "./OrderDetails.vue?vue&type=style&index=2&id=517aa08f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517aa08f",
  null
  
)

export default component.exports